import { Navigate } from "react-router-dom";
import Loading from "../../components/common/loading";
import useStore from "../../features/store";
import { LayoutType } from "../interfaces";

const DashboardLayout = ({ children }: LayoutType) => {
  //@ts-ignore
  const { isLoadingProfile, profile } = useStore();

  if (isLoadingProfile) {
    return <Loading />;
  } else if (!isLoadingProfile && profile) {
    if (profile?.role === "SAD") {
      return <div>{children}</div>;
    } else {
      return <Navigate to="/404" />;
    }
  } else {
    return <div></div>;
  }
};

export default DashboardLayout;
